var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrendArrIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 21,
    viewBox: "0 0 42 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 10.5C31.3529 12.0385 28.3011 14.1518 24.2941 20.5C27.1176 13.9286 31.1176 10.5 41 10.5Z",
    fill: "#3E2313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10.5C31.3529 8.96154 28.3011 6.84819 24.2941 0.500001C27.1176 7.07143 31.1176 10.5 41 10.5Z",
    fill: "#3E2313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00008 10.5L41 10.5M41 10.5C31.3529 8.96154 28.3011 6.84819 24.2941 0.500001C27.1176 7.07143 31.1176 10.5 41 10.5ZM41 10.5C31.3529 12.0385 28.3011 14.1518 24.2941 20.5C27.1176 13.9286 31.1176 10.5 41 10.5Z",
    stroke: "#6C584C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrendArrIc);
export default __webpack_public_path__ + "static/media/brendArr_ic.2d33defa2739c23e05fa89a745423f1a.svg";
export { ForwardRef as ReactComponent };